import { useReducer } from 'react'
import TimerContext from './timer-context'
const defaultResetTime = 30; // how many seconds to countdown for the timer
const defaultTimerState = {
    timer: defaultResetTime,

}
export let timeTaken = 0;
const timerReducer = (state, action) => {
    if (action.type == 'COUNT_DOWN') {
        if (state.timer >= 0) {
            timeTaken = defaultResetTime - state.timer;
            return {
                timer: state.timer - 1
            }
        }
    }
    else if (action.type == 'RESET_TIMER') {
        timeTaken = defaultResetTime - state.timer;
        return {
            timer: defaultResetTime
        }
    }
    return defaultTimerState;
}

const TimerProvider = props => {

    const [timerState, dispatchTimerState] = useReducer(timerReducer, defaultTimerState)
    const resetTimer = () => {
        dispatchTimerState({ type: 'RESET_TIMER' })
    }
    const countDown = () => {
        dispatchTimerState({ type: 'COUNT_DOWN' })
    }

    const timerContext = {
        timer: timerState.timer,
        resetTimer: resetTimer,
        countDown: countDown
    }
    return (<TimerContext.Provider value={timerContext}>
        {props.children}
    </TimerContext.Provider>)
}

export default TimerProvider;